import React from "react";
import validate from "validate.js";
import { Link } from "gatsby"
import simpleXHR from "./simpleXHR";
import config from "../../config/config";
import Uploader from "../Uploader";
import style from "./index.module.css";

export default class ChallengeForm extends React.Component {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUploadSuccess = this.handleUploadSuccess.bind(this);
    this.handleMessageClose = this.handleMessageClose.bind(this);
    this.handleEmailSendError = this.handleEmailSendError.bind(this);
    this.handleEmailSendSuccess = this.handleEmailSendSuccess.bind(this);
    this.state = {
      formData: {
        projectName: "",
        groupName: "",
        groupSize: "",
        averageAge: "",
        spokesman: "",
        email: "",
        phone: "",
        description: "",
        planPublicUrl: null,
        videoPublicUrl: null,
        publicProject: false,
        newsletter: false,
        termsAccepted: false
      },
      validationErrors: null,
      message: null,
      uploadComplete: false,
      formSubmitted: false,
      formToEmailSuccess: false,
      submitButtonText: 'Verstuur je inzending',
      submitButtonEnabled: true
    }
  }

  handleChange(field, value) {
    // eslint-disable-next-line
    this.state.formData[field] = value;
    this.setState({
      formData: this.state.formData,
      validationErrors: null,
      formMessage: "",
    });
  }

  handleSubmit(e) {
    e.preventDefault()
    var validationErrors = validate(this.state.formData, this.getValidationSchema());
    if (typeof validationErrors === "undefined") {
      this.setState({
        submitButtonText: "Versturen ...",
        submitButtonEnabled: false,
      })
      simpleXHR("POST", config.mailSenderEndpoint, this.state.formData, this.handleEmailSendSuccess, this.handleEmailSendError);
    } else {
      this.setState({ validationErrors })
    }
  }

  handleEmailSendError(message) {
    this.setState({
      formMessage: "Sorry er is iets misgegaan met het versturen van je inzending. Je inzending is niet verstuurd.",
      submitButtonText: "Verstuur je inzending",
      submitButtonEnabled: true,
    })
  }

  handleEmailSendSuccess(message) {
    this.setState({
      formSubmitted: true,
      formToEmailSuccess: true,
      submitButtonText: "Inzending is verstuurd",
    })
    this.props.onSuccess && this.props.onSuccess();
  }

  handleUploadSuccess(publicUrl) {
    var formData = this.state.formData;
    formData.planPublicUrl = publicUrl;
    this.setState({
      uploadComplete: true,
      formData: formData,
      validationErrors: null,
      message: "",
    })
  }

  handleMessageClose(e) {
    e.preventDefault()
    this.setState({
      message: "",
      validationErrors: null,
    })
  }

  getValidationSchema() {
    validate.validators.isTrue = (value, options) => value !== true ? options.message : null;
    return {
      email: {
        presence: {
          message: "^E-mailadres is niet ingevuld",
        },
        email: {
          message: "^Geen geldig e-mailadres",
        },
      },
      projectName: {
        presence: {
          message: "^Projectnaam is niet ingevuld",
        },
      },
      groupSize: {
        presence: {
          message: "^Aantal personen is niet ingevuld",
        },
      },
      averageAge: {
        presence: {
          message: "^Gemiddelde leeftijd is niet ingevuld",
        },
      },
      spokesman: {
        presence: {
          message: "^Naam van de vertegenwoordiger is niet ingevuld",
        },
      },
      phone: {
        presence: {
          message: "^Telefoonnummer van de vertegenwoordiger is niet ingevuld",
        },
      },
      description: {
        presence: {
          message: "^Beschrijving is niet ingevuld",
        },
      },
      planPublicUrl: {
        presence: {
          message: "^Je hebt nog geen plan geupload",
        },
        url: {
          allowLocal: true,  // TODO: turn off after testing
          message: "^Je hebt nog geen plan geupload",
        },
      },
      // videoPublicUrl: {
      //   url: {
      //     message: "^Video url is geen geldige url",
      //   },
      // },
      termsAccepted: {
        isTrue: {
          message: "^Je moet de voorwaarden accepteren",
        },
      }
    }
  }

  renderValidationErrors(validationErrors) {
    let listItems = [];
    for (var key in validationErrors) {
      if (validationErrors.hasOwnProperty(key)) {
        var msg = validationErrors[key];
        listItems.push(<li key={key}>{msg}</li>);
      }
    }
    return listItems;
  }

  render() {
    var ageOptions = ["", "Onder de 15 jaar", "Onder 25 jaar", "Ouder dan 25 jaar", "Ouder dan 50 jaar"];
    return (
      <div>
        <form className={style.form} onSubmit={this.handleSubmit}>
          <h1 className={style.title}>Stuur je plan in</h1>

          <label className={style.label} htmlFor="projectName">Ons project heet</label>
          <input className={style.input} type="text" name="projectName" id="projectName" defaultValue={this.state.formData.projectName} onChange={(e) => this.handleChange("projectName", e.currentTarget.value)} />

          <label className={style.label} htmlFor="groupName">Onze groep heet</label>
          <input className={style.input} type="text" name="groupName" id="groupName" defaultValue={this.state.formData.groupName} onChange={(e) => this.handleChange("groupName", e.currentTarget.value)} />

          <label className={style.label} htmlFor="groupSize">En bestaat uit … mensen</label>
          <input className={style.input} type="number" name="groupSize" id="groupSize" defaultValue={this.state.formData.groupSize} onChange={(e) => this.handleChange("groupSize", e.currentTarget.value)} />

          <label className={style.label} htmlFor="averageAge">Wij zijn ‘gemiddeld’</label>
          <select className={style.select} name="averageAge" id="averageAge" defaultValue={this.state.formData.averageAge} onChange={(e) => this.handleChange("averageAge", e.currentTarget.value)}        >
            {ageOptions.map((option, i) => {
              return <option value={option} key={i}>{option}</option>
            })}
          </select>

          <label className={style.label} htmlFor="spokesman">Onze woordvoerder heet</label>
          <input className={style.input} type="text" name="spokesman" id="spokesman" autoComplete="name" defaultValue={this.state.formData.spokesman} onChange={(e) => this.handleChange("spokesman", e.currentTarget.value)} />

          <label className={style.label} htmlFor="email">En is bereikbaar via e-mailadres</label>
          <input className={style.input} type="email" name="email" id="email" autoComplete="email" defaultValue={this.state.formData.email} onChange={(e) => this.handleChange("email", e.currentTarget.value)} />

          <label className={style.label} htmlFor="phone">En telefoonnummer</label>
          <input className={style.input} type="tel" name="phone" id="phone" autoComplete="phone" defaultValue={this.state.formData.phone} onChange={(e) => this.handleChange("phone", e.currentTarget.value)} />

          <label className={style.label} htmlFor="description">Als we ons project in 5 regels moeten vertellen zeggen we altijd</label>
          <textarea className={style.textarea} name="description" id="description" defaultValue={this.state.formData.description} onChange={(e) => this.handleChange("description", e.currentTarget.value)}></textarea>

          <div className={style.uploadContainer}>
            <label className={style.label}>Projectplan (PDF-document)</label>
            {Uploader &&
              <Uploader fineUploaderOptions={config.fineUploaderTraditionalOptions} type="traditional" label="Upload je plan" onSuccess={this.handleUploadSuccess} accept="application/pdf" invalidTypeMessage="Het bestand is geen pdf" />
            }
            {this.state.uploadComplete &&
              <div className={style.uploadComplete}>
                Vergeet niet het formulier te versturen.
              </div>
            }
          </div>

          <label className={style.label} htmlFor="videoPublicUrl">Link naar een foto of een video over het project (optioneel)</label>
          <input className={style.input} type="text" name="videoPublicUrl" id="videoPublicUrl" defaultValue={this.state.formData.videoPublicUrl} onChange={(e) => this.handleChange("videoPublicUrl", e.currentTarget.value)} />

          <label className={style.labelInlineContainer} htmlFor="publicProject">
            <input className={style.checkbox} type="checkbox" name="publicProject" id="publicProject" ref="publicProject" defaultChecked={false} onChange={(e) => this.handleChange("publicProject", e.currentTarget.checked)} />
            <div className={style.labelInline}>Ja, ik wil graag meedoen met de <Link to="/challenge#publieksprijs">publieksprijs</Link> en ga ermee akkoord dat de namen van het project, de groep en de woordvoerder en de beschrijving van het project op de website staan. (optioneel)</div>
          </label>

          <label className={style.labelInlineContainer} htmlFor="newsletter">
            <input className={style.checkbox} type="checkbox" name="newsletter" id="newsletter" ref="newsletter" defaultChecked={false} onChange={(e) => this.handleChange("newsletter", e.currentTarget.checked)} />
            <div className={style.labelInline}>Ja, ik Ontvang graag de Hilversum100 Bijprater (nieuwsbrief 6x per jaar). (optioneel)</div>
          </label>

          <label className={style.labelInlineContainer} htmlFor="termsAccepted">
            <input className={style.checkbox} type="checkbox" name="termsAccepted" id="termsAccepted" ref="termsAccepted" defaultChecked={false} onChange={(e) => this.handleChange("termsAccepted", e.currentTarget.checked)} />
            <div className={style.labelInline}>Ja, ik accepteer de <a className={style.link} href="/voorwaarden" target="_blank">projectvoorwaarden</a></div>
          </label>

          <div>
            <button ref="confirmationButton" disabled={!this.state.submitButtonEnabled} className={style.button}>{this.state.submitButtonText}</button>
          </div>

        </form>

        {(this.state.validationErrors || this.state.message) &&
          <div className={style.formMessage}>
            <div>
              {this.state.message &&
                <div>{this.state.message}</div>
              }
            </div>
            {(this.state.validationErrors) &&
              <div>
                <div>Niet alle formuliervelden zijn correct ingevuld:</div>
                <ul>
                  {this.renderValidationErrors(this.state.validationErrors)}
                </ul>
              </div>
            }
            <div className="form-message-close" onClick={this.handleMessageClose}>Sluit</div>
          </div>
        }
      </div>

    )
  }
}